import styled from "styled-components";
import { theme } from "../../../config";
import Button from "../../atoms/Button/Button";

export const ButtonsWrapper = styled.div`
  text-align: center;
  margin: 35px 0 100px 0;

  #grayButton {
    background-color: ${theme.colors.neutral.black6};
    border: 1.5px solid ${theme.colors.neutral.black6};
  }

  #grayButton:hover {
    background-color: ${theme.colors.neutral.black7};
    border: 1.5px solid ${theme.colors.neutral.black7};
  }

  #grayButton:focus {
    background-color: ${theme.colors.neutral.black5};
    border: 1.5px solid ${theme.colors.neutral.black5};
  }

  @media ${theme.breakpoints.mobileAndTablet} {
    margin: 26px 0 100px 0;
  }
`;

export const ButtonStyled = styled(Button)`
  margin: 10px;
`;
